import cloud1 from "./cloud1.svg";
import cloud2 from "./cloud2.svg";
import cloud3 from "./cloud3.svg";
import coupleTalk from "./couple-talk.svg";
import bgLanding from "./bg-landing.svg";
import cloudChannel from "./cloud-channel.svg";

export default {
  cloud1,
  cloud2,
  cloud3,
  coupleTalk,
  bgLanding,
  cloudChannel
};
